import { useState } from 'react';
import { c, t } from '../../theme';

// Renders only the first `limit` rows of a long table, with a footer row to
// reveal more. The Staffing Tracker's "all cost centers" view holds over a
// thousand Drivers at 15 editable date inputs each; mounting all of them took
// seconds, and it happened on every change of cost-center focus. Sorting and
// filtering still act on the full list -- this only caps what is drawn.
//
// The reveal resets whenever the number of rows changes (a new focus or filter
// is a new result set), so coming back to the long view starts short again.
export function useRowLimit(rows, limit = 100) {
  const [state, setState] = useState({ len: rows.length, shown: limit });
  const shown = state.len === rows.length ? state.shown : limit;
  return {
    visible: rows.length > shown ? rows.slice(0, shown) : rows,
    shown: Math.min(shown, rows.length),
    total: rows.length,
    more: () => setState({ len: rows.length, shown: shown + limit }),
    all: () => setState({ len: rows.length, shown: rows.length }),
  };
}

export function ShowMoreRow({ limiter, colSpan }) {
  if (limiter.shown >= limiter.total) return null;
  return (
    <tr>
      <td colSpan={colSpan} style={s.cell}>
        Showing {limiter.shown.toLocaleString('en-US')} of {limiter.total.toLocaleString('en-US')}
        <button type="button" style={s.btn} onClick={limiter.more}>Show 100 more</button>
        <button type="button" style={s.btn} onClick={limiter.all}>Show all</button>
      </td>
    </tr>
  );
}

const s = {
  cell: { padding: '12px 14px', textAlign: 'center', fontSize: t.caption.fontSize, color: c.textMuted, background: c.surfaceSunk },
  btn:  { all: 'unset', cursor: 'pointer', marginLeft: '14px', color: c.info, fontWeight: 600 },
};
